"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import styled from "styled-components";
const SVG = styled.svg`
  min-width: ${({ $size }) => $size};
  max-width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
`;
const Notes = ({ size = "1em", color = "currentColor", title, ...props }) => /* @__PURE__ */ jsxs(SVG, { ...props, $size: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: title ? "img" : "presentation", children: [
  title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
  " ",
  /* @__PURE__ */ jsx("path", { fill: color, d: "M22.36 2.58a.755.755 0 0 0-.75-.75H5.11a.756.756 0 0 0-.53.22.794.794 0 0 0-.22.53V4H2.75a.716.716 0 0 0-.53.22.775.775 0 0 0-.22.53v16.5a.73.73 0 0 0 .72.75h10.04a.732.732 0 0 0 .55-.25l.01-.01 8.76-8.37a.732.732 0 0 0 .28-.68zM12.8 14.25a.755.755 0 0 0-.75.75v5.5H3.5v-15h15v8.75zm8.06-2.17H20V4.75a.749.749 0 0 0-.75-.75H5.86v-.67h15z", children: " " })
] });
var Notes_default = Notes;
export {
  Notes_default as default
};
